import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";

import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";

import useCsrFederalLevel from "./hooks/useCsrFederalLevel";

const CsrFederalLevel = ({
  onSelect,
  hideModal,
  params,
  lookupType,
  selectModeParamData,
}) => {
  const csrFederalLevelData = useCsrFederalLevel(
    onSelect,
    hideModal,
    params,
    lookupType,
    selectModeParamData
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={csrFederalLevelData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {csrFederalLevelData.screen_title} -{" "}
          <span className="heading-cod">
            {csrFederalLevelData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={csrFederalLevelData.formFields}
        dropdownValues={csrFederalLevelData.dropdownValues}
        paramsData={csrFederalLevelData.paramsData}
        updataParamData={csrFederalLevelData.updateParamData}
      />
      <ButtonsSection ctaButtons={csrFederalLevelData.ctaButtons} />
      <DisplayTable
        data={csrFederalLevelData.data}
        parmKey={csrFederalLevelData.parmKey}
        menuOptions={csrFederalLevelData.menuOptions}
        tableHeaders={csrFederalLevelData.columnDef}
        setRowData={csrFederalLevelData.setRowData}
        selectedPriceSchedules={csrFederalLevelData.selectedRows}
        setSelectedPriceSchedules={csrFederalLevelData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={csrFederalLevelData.first}
          rows={csrFederalLevelData.rows}
          totalRecords={csrFederalLevelData.totalRecords}
          currentPage={csrFederalLevelData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={csrFederalLevelData.onPageChange}
        />
      </div>
      {csrFederalLevelData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={csrFederalLevelData.isConfirmationModalOpen}
          onRequestClose={csrFederalLevelData.closeConfirmationModal}
          onBack={csrFederalLevelData.closeConfirmationModal}
          onSave={csrFederalLevelData.deleteCsrFederalLevel}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={csrFederalLevelData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default CsrFederalLevel;
